var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinterest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Graphic_Elements",
    clipPath: "url(#clip0_882_7486)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.9653 0.806641C9.45761 0.806641 0.938232 9.32601 0.938232 19.8337C0.938232 27.8968 5.94847 34.7884 13.0259 37.5597C12.8541 36.0557 12.7133 33.7379 13.0878 32.096C13.4314 30.609 15.3127 22.6388 15.3127 22.6388C15.3127 22.6388 14.7495 21.4953 14.7495 19.8196C14.7495 17.1723 16.2844 15.2009 18.1938 15.2009C19.8217 15.2009 20.6046 16.4231 20.6046 17.8792C20.6046 19.507 19.571 21.9516 19.0218 24.2215C18.5684 26.1169 19.9766 27.6659 21.841 27.6659C25.2234 27.6659 27.8228 24.0948 27.8228 18.9607C27.8228 14.4038 24.5503 11.2242 19.8667 11.2242C14.4481 11.2242 11.2713 15.2797 11.2713 19.476C11.2713 21.1039 11.8965 22.8584 12.6795 23.8132C12.8372 24.0019 12.8513 24.1737 12.8034 24.3624C12.6626 24.9566 12.3331 26.2577 12.2711 26.5225C12.1923 26.8661 11.9895 26.9449 11.629 26.7731C9.2492 25.6607 7.76218 22.1994 7.76218 19.3972C7.76218 13.3984 12.1162 7.88688 20.3371 7.88688C26.9301 7.88688 32.067 12.5845 32.067 18.879C32.067 25.1735 27.9327 30.716 22.2015 30.716C20.2751 30.716 18.4586 29.7134 17.8474 28.5249C17.8474 28.5249 16.8927 32.1579 16.6561 33.0507C16.2337 34.7095 15.0734 36.7767 14.2904 38.0469C16.076 38.5961 17.9545 38.8918 19.9287 38.8918C30.4364 38.8918 38.9558 30.3724 38.9558 19.8647C38.9896 9.32602 30.4702 0.806641 19.9653 0.806641Z",
    fill: "#010201"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_882_7486"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.0204,
    height: 38.0823,
    fill: "white",
    transform: "translate(0.938232 0.806641)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterest);
export default __webpack_public_path__ + "static/media/pinterest.84e9baa82f6c9b98be770a0d9a8b641d.svg";
export { ForwardRef as ReactComponent };